<template>
  <ul class="menu-list">
    <li
      v-for="(item, index) in navList"
      :key="index"
      class="menu-item-has-children"
      :class="{ active: item.active, open: item.open }"
      @click.capture="handleItemCapture($event, item)"
      @click.stop="handleItemClick(item, index)"
    >
      <router-link
        :to="item.path"
        class="drop-down"
        :class="{ 'page-active': item.active }"
      >
        {{ item.name }}
      </router-link>

      <SubMenu
        v-if="item.children.length > 0"
        :items="item.children"
        :isMobile="isMobile"
        :isVisible="isMenuVisible && (isMobile ? item.open : item.active)"
        @item-click="handleSubItemClick"
      />
    </li>
  </ul>
</template>

<script>
import SubMenu from "./SubMenu.vue";

export default {
  name: "NavigationMenu",
  components: { SubMenu },
  props: {
    navList: Array,
    isMenuVisible: Boolean,
    // 移动端（≤991px）一级项改为"抽屉开关"：点击只展开/收起子菜单，不跳转
    isMobile: Boolean,
  },
  methods: {
    // 移动端且带子项 → 该项点击语义是"展开"而非"跳转"
    isExpandable(item) {
      return this.isMobile && item.children && item.children.length > 0;
    },
    // 点击是否来自"当前项的下级子菜单"。
    // 捕获阶段由外到内，二级/三级项的点击会先撞上本级的 @click.capture；
    // 若不区分就会被本级吞掉（表现为点叶子项不跳转）。
    isFromChildMenu(e) {
      var sm = e.target && e.target.closest ? e.target.closest(".sub-menu") : null;
      return !!sm && e.currentTarget !== sm && e.currentTarget.contains(sm);
    },
    // 捕获阶段拦截：阻止 router-link 的导航（其内部会检查 defaultPrevented）与冒泡，
    // 只切换展开态；不 emit nav-click，避免父组件把整个抽屉关掉
    handleItemCapture(e, item) {
      if (!this.isExpandable(item)) return;
      if (this.isFromChildMenu(e)) return;
      e.preventDefault();
      e.stopPropagation();
      this.$set(item, "open", !item.open);
      // 预渲染+水合环境下，直接改 prop 嵌套属性不触发子组件重渲染，
      // 强制本组件（含递归 SubMenu 子组件）重渲染以同步展开态
      this.$forceUpdate();
    },
    // 冒泡阶段：能走到这里的都是"跳转"型（展开型已在捕获阶段被截断）
    handleItemClick(item, index) {
      this.$emit("nav-click", {
        level: 1,
        indexes: [index],
      });
    },
    handleSubItemClick({ level, indexes }) {
      this.$emit("nav-click", { level, indexes });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/components/NavigationMenu.vue